import { NotifyHelper } from "../../../helpers/toast";
import { eMucTriNangActionsObj } from "../../action-types/category/IMucTriNangActions";
import { generateActionForKey, generateActions } from "../generateActions";

export const mucTriNangActions = {
  ...generateActions(eMucTriNangActionsObj, "MUC_TRI_NANG"),
  ...generateActionForKey(
    eMucTriNangActionsObj,
    "MUC_TRI_NANG",
    "SAVE_SUCCESS",
    () => {
      NotifyHelper.Success("Đã cập nhật");
    }
  ),
  ...generateActionForKey(
    eMucTriNangActionsObj,
    "MUC_TRI_NANG",
    "SAVE_ERROR",
    (m: string) => {
      NotifyHelper.Error(m);
    }
  ),
  ...generateActionForKey(
    eMucTriNangActionsObj,
    "MUC_TRI_NANG",
    "DELETE_SUCCESS",
    () => {
      NotifyHelper.Success("Đã xóa");
    }
  ),
  ...generateActionForKey(
    eMucTriNangActionsObj,
    "MUC_TRI_NANG",
    "DELETE_ERROR",
    (m: string) => {
      NotifyHelper.Error(m);
    }
  ),
};
